/**
 * Root component: provider tree + router.
 */
import { Route, Routes } from 'react-router-dom'
import { Layout } from '@/components/layout'
import { ProtectedRoute } from '@/components/protected-route'
import { AuthProvider } from '@/providers/auth-provider'
import { QueryProvider } from '@/providers/query-provider'
import { SocketProvider } from '@/providers/socket-provider'
import DashboardTab from '@/pages/dashboard/dashboard-tab'
import AgentDiagnosticsPage from '@/pages/diagnostics/agent-diagnostics-page'
import DiagnosticsTab from '@/pages/diagnostics/diagnostics-tab'
import EmployeeDetailPage from '@/pages/employees/employee-detail-page'
import EmployeesTab from '@/pages/employees/employees-tab'
import LogsTab from '@/pages/logs/logs-tab'
import LoginPage from '@/pages/login-page'

export default function App() {
  return (
    <QueryProvider>
      <AuthProvider>
        <SocketProvider>
          <Routes>
            <Route path="/login" element={<LoginPage />} />
            <Route
              element={
                <ProtectedRoute>
                  <Layout />
                </ProtectedRoute>
              }
            >
              <Route index element={<DashboardTab />} />
              <Route path="dashboard" element={<DashboardTab />} />
              <Route path="employees" element={<EmployeesTab />} />
              <Route path="employees/:id" element={<EmployeeDetailPage />} />
              <Route path="diagnostics" element={<DiagnosticsTab />} />
              <Route path="diagnostics/:id" element={<AgentDiagnosticsPage />} />
              <Route path="logs" element={<LogsTab />} />
            </Route>
          </Routes>
        </SocketProvider>
      </AuthProvider>
    </QueryProvider>
  )
}
